import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import { useRestrictedAccess } from '../../hooks/use-restricted-access';
import type { RouterOutletContext } from '../router';

const RestrictedAccessWrapper = ({ blockBilling = false, blockDispatch = false }: { blockBilling?: boolean; blockDispatch?: boolean }) => {
    const context = useOutletContext<RouterOutletContext>();
    const { isBillingUser, isDispatchUser } = useRestrictedAccess();

    if ((blockBilling && isBillingUser) || (blockDispatch && isDispatchUser)) {
        return <Navigate to="/404" replace />;
    }

    return <Outlet context={context} />;
};

export default RestrictedAccessWrapper;
